/**
 * VitalsTab.jsx
 *
 * Full vitals module:
 * - Add vitals entry
 * - Show history table
 */

import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import VitalsForm from "../vitalsForm";
import VitalsTable from "../vitalsTable";

export default function VitalsTab({ residentId }) {
    const [refreshKey, setRefreshKey] = useState(0);

    // When form saves successfully, refresh table
    const refresh = () => setRefreshKey((k) => k + 1);

    return (
        <Box sx={{ p: 1 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Vitals Monitoring
            </Typography>

            {/* Entry Form */}
            <VitalsForm residentId={residentId} onSave={refresh} />

            <Divider sx={{ my: 3 }} />

            {/* History Table */}
            <VitalsTable residentId={residentId} refreshKey={refreshKey} />

        </Box>
    );
}
